import React, {Component} from 'react';
import AppNavigation from './AppNavigation';
import AppFooter from './AppFooter';
import SubAdminApplicationDetail from './Subcomponents/AdminApplicationDetail';
import withRouter from './Functions/WithRouter';

class AdvApplicationDetail extends Component {
    constructor(props) {
      super(props)
      this.state = {
      }
    }

    componentDidMount() {
      document.body.style.backgroundColor = "rgba(178,186,191,0.2)";

      let selectedJob = null
      let selectedApplication = null
      let benchmark = null
      let benchmarkOptions = null
      let id = null
      if (this.props.location && this.props.location.state) {
        selectedJob = this.props.location.state.selectedJob
        selectedApplication = this.props.location.state.selectedApplication
        benchmark = this.props.location.state.benchmark
        benchmarkOptions = this.props.location.state.benchmarkOptions
      }

      if (this.props.params) {
        id = this.props.params.id
      }

      let email = localStorage.getItem('email');
      let roleName = localStorage.getItem('roleName');
      const username = localStorage.getItem('username');
      const cuFirstName = localStorage.getItem('firstName');
      const cuLastName = localStorage.getItem('lastName');
      const activeOrg = localStorage.getItem('activeOrg');
      const orgFocus = localStorage.getItem('orgFocus');
      const orgLogo = localStorage.getItem('orgLogo');

      this.setState({ roleName, orgLogo, emailId: email, username,
        cuFirstName, cuLastName, activeOrg, orgFocus,
        selectedJob, selectedApplication, benchmark, benchmarkOptions, id
      })
    }

    render() {

      return (
        <div>
          <AppNavigation username={this.state.username} fromAdvisor={true} activeOrg={this.state.activeOrg} orgFocus={this.state.orgFocus} roleName={this.state.roleName} history={this.props.navigate} />

          <SubAdminApplicationDetail accountCode={this.state.emp} org={this.state.activeOrg} id={this.state.id} selectedJob={this.state.selectedJob} selectedApplication={this.state.selectedApplication} benchmark={this.state.benchmark} benchmarkOptions={this.state.benchmarkOptions} />
          {(this.state.activeOrg) && (
            <div>
              {AppFooter(this.props.navigate,this.state.activeOrg,this.state.orgLogo)}
            </div>
          )}
        </div>
      )
    }
}

export default withRouter(AdvApplicationDetail);
